import { render, staticRenderFns } from "./ChamadoFluxoTransicao.vue?vue&type=template&id=53cc6397&"
import script from "./ChamadoFluxoTransicao.vue?vue&type=script&lang=js&"
export * from "./ChamadoFluxoTransicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports